import React, { useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { loadingToggleAction } from "../../../store/actions/AuthActions";
import logoFull from "../../../assets/images/rajdhani.png";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TElogo from "../../../assets/images/logopng-17.png";
import { Toaster } from "../../components/Toaster/Toster";
import BtnLoader from "../../components/Loader/btnLoader";
import { UserChangePasswordApi, UserResetPasswordApi } from "../../../services/apis/UserProfile";
import Swal from "sweetalert2";


function ResetPassword() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({ password: "", confirmPassword: "" });
  const [btnLoading,setBtnLoading]=useState(false);
  const navigate = useNavigate();

  const validateFields = () => {
    let errorObj = { password: "", confirmPassword: "" };
    let isError = false;

    if (!password) {
      errorObj.password = "Password is required";
      isError = true;
    }

    if (!confirmPassword) {
      errorObj.confirmPassword = "Confirmation password is required";
      isError = true;
    } else if (password !== confirmPassword) {
      errorObj.confirmPassword = "Passwords do not match";
      isError = true;
    }

    setErrors(errorObj);
    return isError;
  };

  // Reset the specific error when the user starts typing
  const handleInputChange = (e, field) => {
    const value = e.target.value;
    if (field === "password") {
      setPassword(value);
      if (submitted && errors.password) {
        setErrors((prevErrors) => ({ ...prevErrors, password: "" }));
      }
    } else if (field === "confirmPassword") {
      setConfirmPassword(value);
      if (submitted && errors.confirmPassword) {
        setErrors((prevErrors) => ({ ...prevErrors, confirmPassword: "" }));
      }
    }
  };

  const onSubmit=async(e)=> {
    e.preventDefault();
    setSubmitted(true);

    if (validateFields()) {
      return;
    }
    
    const fData={
        password: password,
        confirm_password: confirmPassword  
      }
      setBtnLoading(true);
      try{
        const res = await UserResetPasswordApi(fData); 
         if(res?.data?.success) {
             //Toaster.success(res?.data?.message);
            Swal.fire({
             icon: "success",
             title: "Password Change Successful",
             text: res?.data?.message
           });
           navigate("/dashboard");           
        }

      }catch(err){
        //  console.log("RESETERR",err);
         Toaster.error(err?.response?.data?.message);
      }finally{
        setBtnLoading(false);
      }
  }

  return (
    <>
      <ToastContainer />
      <div className="fix-wrapper py-0">
        <div className="w-100">
          <div className="row login-mainsection-background">
            <div className="col-12 col-lg-12 login-right-section d-flex flex-column justify-content-center">
              <div className="login-right-content-section">
                <div className="card login-card mb-0 h-auto">
                  <div className="card-body">
                    {/* Logo */}
                    <div className="d-flex justify-content-center mb-2">
                      <Link to={"/dashboard"}>
                        <img
                          src={TElogo}
                          alt="logo"
                          style={{ height: "80px", width: "auto" }}
                        />
                      </Link>
                    </div>
                    {/* Tagline */}
                    <h4 className="login-welcome-text">Change Your Password</h4>
                    <form onSubmit={onSubmit}>
                      {/* New Password */}
                      <div className="mb-3 mt-3">
                        <label className="mb-1 text-dark">
                          <strong>New Password</strong>
                        </label>
                        <input
                          type="password"
                          className="form-control"
                          value={password}
                          placeholder="Enter your new password"
                          onChange={(e) => handleInputChange(e, "password")}
                        />
                        {errors.password && (
                          <div className="text-danger fs-12">
                            {errors.password}
                          </div>
                        )}
                      </div>

                      {/* Confirm Password */}
                      <div className="mb-4">
                        <label className="mb-1 text-dark">
                          <strong>Confirm New Password</strong>
                        </label>
                        <input
                          type="password"
                          className="form-control"
                          value={confirmPassword}
                          placeholder="Confirm your new password"
                          onChange={(e) => handleInputChange(e, "confirmPassword")}
                        />
                        {errors.confirmPassword && (
                          <div className="text-danger fs-12">
                            {errors.confirmPassword}
                          </div>
                        )}
                      </div>

                      {/* Submit Button */}
                      <div className="text-center">
                        <button
                          type="submit"
                          className="btn text-white btn-block handle-login-btn">
                          {btnLoading && <BtnLoader/> }
                           Submit
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ResetPassword;
